<template>
  <div class="notification">
    <v-container fluid>
      <!-- <h1 class="textColor font-weight-black display-1 text-md-center">Notification</h1> -->
      <!-- <div class="pa-3" v-for="i in AdminRequest" :key="i"> -->
      <div class="pa-2" v-for="Admin in notificationData" id="notificationWindow">
        <v-card class="pa-2">
          <!-- <notification-click ></notification-click> -->
          <v-layout row wrap>
            <v-flex xs1 class="pa-3">
              <v-img :src="Img"/>
            </v-flex>
            <v-flex xs5>
             <!-- <h4>Payment request</h4>-->
              <br>
              <!--<span class="headline font-weight-black">{{Admin.club_name}}</span>
              <br>
              <span class="title font-weight-bold">{{Admin.admin_name}}</span>
              <br>
              <span class="subheading">Account number</span>
              <br>-->
              <span class="body-2" style="text-align:center">{{Admin.message}}</span>
              <br>
              <!-- <span class="body-2" style="text-align:justify"> {{Admin.request_message}}</span> -->
            </v-flex>
            <!-- <v-flex xs2>15500$</v-flex> -->
          </v-layout>
        </v-card>
      </div>
    </v-container>
    <!-- <notifications group="error" position="bottom center"/>
    <notifications group="Success" position="bottom center"/>-->
  </div>
</template>

<script>
/* eslint-disable */

import { dispatch, mapState, mapActions } from "vuex";

import NotificationClick from "./NotificationClick";
// import Pusher from 'pusher-js';
export default {
  name: "Customer",
  data: () => ({
    Img: "https://bootdey.com/img/Content/avatar/avatar7.png"
  }),
  created: () => {
    Store.dispatch("GetAllRequest").then(
      res => {

        var notificationData = res.data.data;

        var TempArray = [];
        for (var i = 0; i < notificationData.length; i++) {
          TempArray.push({
            id: notificationData[i].id,
            user_id: notificationData[i].user_id,
            // admin_id: RequestsData[i].admin_id,
            // admin_name: RequestsData[i].admin_name,
            // admin_email: RequestsData[i].admin_email,
            // club_name: RequestsData[i].club_name,
            date: notificationData[i].date,
            time: notificationData[i].time,
            type: notificationData[i].type,
            message: notificationData[i].message,
            user_name: notificationData[i].user_name,
            user_image: notificationData[i].user_image,
            // status: RequestsData[i].status
          });
        }
        this.notificationData = TempArray;
        Store.state.notificationData = TempArray;
      },
      error => {

        this.$notify({
          group: "error",
          type: "error",
          text: error.message
        });
      }
    );
  },

  mounted:function(){
        // var el = document.getElementById('#notificationWindow')
        //  console.log(el)
        // el.scrollTop = el.scrollHeight

        this.pusher=new Pusher('e9455c16bc5f0d6c4547',{
          cluster: 'ap2',
          encrypted: true,
          disableStats: true,
        })
        let self=this
        let pusherToken=Store.state.pusherToken
        this.channel=this.pusher.subscribe(pusherToken);
        let notificationData=Store.state.notificationData
    },

  components: {
    NotificationClick
  },
  computed: mapState(["notificationData"]),
  methods: {
    ar() {
      return this.notificationData[0].id;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/pages/Notification.vue